import { render } from "./FormacaoPrecoModal.vue?vue&type=template&id=00e451f1&scoped=true&ts=true"
import script from "./FormacaoPrecoModal.vue?vue&type=script&lang=ts"
export * from "./FormacaoPrecoModal.vue?vue&type=script&lang=ts"

import "./FormacaoPrecoModal.vue?vue&type=style&index=0&id=00e451f1&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e451f1"]])

export default __exports__